import { render, staticRenderFns } from "./userBankCard.vue?vue&type=template&id=135f09a8&scoped=true&"
import script from "./userBankCard.vue?vue&type=script&lang=js&"
export * from "./userBankCard.vue?vue&type=script&lang=js&"
import style0 from "./userBankCard.vue?vue&type=style&index=0&id=135f09a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135f09a8",
  null
  
)

export default component.exports